module.exports = __webpack_public_path__ + "img/photoThemeValcombe.e7bb37de.png";